import { getDisplayCount } from "@helpers/profileHelper";
import styles from "./ProfilePanel.module.scss";
import LoadingSkeleton from "@shared/LoadingSkeleton";
import UpgradeIconSmall from "@assets/images/zap-icon.svg";
import { useSelector } from "react-redux";

const ProfilePanel = ({ panelData, handlePanelClick, activePanelId, loading = false, loadingWidth = "40rem" }) => {
  const query = new URLSearchParams(window.location.search);
  const mergedID = query.get("mergedID");
  const planAccess = useSelector((state) => state.userDetails.creditDetails.planAccess);
  return (
    <div className={styles.profilePanel}>
      {loading ? (
        <LoadingSkeleton width={loadingWidth} height={"1.5rem"} margin={"0.5rem"} />
      ) : (
        <div className={`${styles.panelTexts} ${window.location.pathname.includes("/companies") ? "!tw-ml-3" : ""}`}>
          {panelData.map(({ id, text, count, countEnum, upgradeIconEnum }) => {
            if (!(id === "contact_details" && mergedID))
              return (
                <span
                  id={id}
                  className={`${styles.text} ${activePanelId === id && styles.panelActive}`}
                  key={id}
                  onClick={() => {
                    handlePanelClick(id, countEnum);
                  }}>
                  <div className="tw-flex tw-gap-1">
                    {text}
                    {count ? <span className={`${styles.count} ${activePanelId === id && styles.countActive}`}>{getDisplayCount(count, 2)}</span> : null}
                    {!planAccess[upgradeIconEnum] && upgradeIconEnum ? <img src={UpgradeIconSmall} /> : <></>}
                  </div>
                </span>
              );
          })}
        </div>
      )}
    </div>
  );
};

export default ProfilePanel;
